<template>
  <path
    d="M1.41421 1.67603e-06L8.58579 4.22114e-07C9.47669 2.66344e-07 9.92286 1.07714 9.29289 1.70711L5.70711 5.29289C5.31658 5.68342 4.68342 5.68342 4.29289 5.29289L0.707106 1.70711C0.0771409 1.07714 0.523308 1.8318e-06 1.41421 1.67603e-06Z"
  />
</template>
